/**
 * Labstep
 *
 * @module components/Entity/ActionView
 * @desc Core view action
 */

import { withAuthenticatedUserEntity } from 'labstep-web/containers/AuthenticatedUser';
import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import type { IPermissionRoleActionViewAllProps } from './types';

export const PermissionRoleActionViewAll: React.FC<
  IPermissionRoleActionViewAllProps
> = ({ authenticatedUserEntity }) => {
  if (
    !authenticatedUserEntity.userOrganization?.organization.hasFeatureEnabled(
      'custom_permissions',
    )
  ) {
    return null;
  }
  return (
    <Icon
      route={{
        to: 'organization_show_permissions',
        params: {
          identifier:
            authenticatedUserEntity.userOrganization.organization
              .identifier,
        },
      }}
      name="cog"
      style={{ paddingLeft: '8px' }}
    />
  );
};

export default withAuthenticatedUserEntity(
  PermissionRoleActionViewAll,
);
